import { render } from "./newMessage.vue?vue&type=template&id=3291dd7d&scoped=true"
import script from "./newMessage.vue?vue&type=script&lang=js"
export * from "./newMessage.vue?vue&type=script&lang=js"

import "./newMessage.vue?vue&type=style&index=0&id=3291dd7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3291dd7d"]])

export default __exports__